import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertPaymentEntry = createAsyncThunk('insertPaymentEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPaymentEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPaymentMemo = createAsyncThunk('fetchPaymentMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPaymentMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPaymentRegister = createAsyncThunk('fetchPaymentRegister', async (id) => {
    try {
        const endpoint = id ? `getPaymentRegister&payId=${id}` : 'getPaymentRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPrevBalanceEmpAmt = createAsyncThunk('fetchPrevBalanceEmpAmt', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPrevBalanceEmpAmt&empId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deletePaymentData = createAsyncThunk('deletePaymentData', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deletePaymentHistory&payId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const paymentApiSlice = createSlice({
    name: 'PaymentDatalist',
    initialState: {
        isLoading: false,
        paymemo: null,
        paydata: null,
        prevbal: null,
        delpay: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPaymentMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPaymentMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.paymemo = action.payload;
        });
        builder.addCase(fetchPaymentMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchPaymentRegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPaymentRegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.paydata = action.payload;
        });
        builder.addCase(fetchPaymentRegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPrevBalanceEmpAmt.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPrevBalanceEmpAmt.fulfilled, (state, action) => {
            state.isLoading = false;
            state.prevbal = action.payload;
        });
        builder.addCase(fetchPrevBalanceEmpAmt.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deletePaymentData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deletePaymentData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delpay = action.payload;
        });
        builder.addCase(deletePaymentData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default paymentApiSlice.reducer;
